import type Joi from 'joi';

/**
 * Better semantic/readable form of boolean checking whether something is valid by Joi schema
 */
export const makeIsValid =
  <T = unknown>(schema: Joi.Schema) =>
  (value: unknown): value is T =>
    !schema.validate(value).error;
